import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Camera02 = function Camera02(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2 7.7018C2 6.2096 3.2096 5 4.7018 5a1.801 1.801 0 0 0 1.7087-1.2316L6.5 3.5c.0422-.1266.0633-.1899.0859-.246a2 2 0 0 1 1.7347-1.2503C8.381 2 8.4477 2 8.5811 2h6.8378c.1334 0 .2001 0 .2605.0037a2 2 0 0 1 1.7347 1.2503c.0226.0561.0437.1194.0859.246l.0895.2684A1.801 1.801 0 0 0 19.2982 5C20.7904 5 22 6.2096 22 7.7018V16.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 16.5c2.4853 0 4.5-2.0147 4.5-4.5S14.4853 7.5 12 7.5 7.5 9.5147 7.5 12s2.0147 4.5 4.5 4.5"
    })]
  }));
};
export default Camera02;